import React, { useState } from "react";
import "./radio.scss";
import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { EmailIcon, FedExIcon, PhoneIcon, UpsIcon } from "../../icons/svg";

const MuiRadio = ({
  defaultValue,
  options,
  label,
  onChange,
  value,
  required = false,
  image = false,
  error,
  ...rest
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const handleRadioChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    console.log(defaultValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div className="radioGroup">
      <FormControl>
        <FormLabel id="demo-radio-buttons-group-label">
          {label} {required ? <span style={{ color: "red" }}>*</span> : ""}
        </FormLabel>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={selectedValue}
          onChange={handleRadioChange}
          name="radio-buttons-group"
          row
          {...rest}
        >
          {options.map((option, index) => (
            <FormControlLabel
              key={index}
              value={option.id}
              control={<Radio />}
              label={
                <div className="radioLabel">
                  <div className="radioIcon">
                    {option.methodName === "Email" && (
                      <span>
                        <EmailIcon />
                      </span>
                    )}
                    {option.methodName === "Phone" && (
                      <span>
                        <PhoneIcon />
                      </span>
                    )}
                    {option.img && <img src={option.img} alt="brim" />}
                    <span> {option.displayName}</span>
                    {option.methodName && <span>{option.methodName}</span>}
                    {option.carrierName && <span>{option.carrierName}</span>}
                    {option.carrierName === "UPS" && <UpsIcon />}
                    {option.carrierName === "FedEx" && <FedExIcon />}
                  </div>
                  {option?.partNumbers && <p>{option.partNumbers[0]}</p>}

                  {option.suffix && (
                    <div className="additional-content">{option.suffix}</div>
                  )}
                  {option.content && parseInt(selectedValue) === option?.id ? (
                    <div>{option.content}</div>
                  ) : null}
                </div>
              }
              className={`${
                parseInt(selectedValue) === option?.id
                  ? "checkedLabel"
                  : defaultValue === option?.id
                  ? "checkedLabel"
                  : ""
              }`}
            />
          ))}
        </RadioGroup>
      </FormControl>
      {error && (
        <Alert
          severity="error"
          style={{ padding: "0px 16px", marginTop: "12px" }}
        >
          Select an option
        </Alert>
      )}
    </div>
  );
};

export default MuiRadio;
